<template>
  <el-table
    ref="tableRef"
    :data="tableData"
    row-key="id"
    :tree-props="{ children: 'children' }"
    :row-style="getRowStyle"
  >
    <!-- 項目名の列 -->
    <el-table-column prop="label" />
    <!-- 設定値の列 -->
    <el-table-column prop="value" label="設定値">
      <template v-slot="{ row }">
        <!-- 展開・折り畳み可能な行のみ矢印表示 -->
        <i
          v-if="row.expandable"
          class="el-icon-caret-left arrowIcon"
          :class="{ rotated: row.expanded }"
          @click="toggleRow(row)"
        />
        <!-- value の表示 -->
        <span v-else>{{ row.value }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { THIRD_LEVEL_MENU, BC } from '@/components/pc/radio/ipradio/config/BCconstants.js'

export default {
  name: 'WiFiSettingsTableVue2',

  props: {
    first: {
        type: String,
        required: true
    },
    second: {
        type: String,
        required: true
    },
    setting: {
        type: Object,
        required: false,
    },
  },

  data () {
    return {
      tableData: [],
      // 常時展開しておきたい行の id（第2階層）を保持
      expandedRows: [],
    }
  },
  computed: {
    firstLevel () { return this.first },
    secondLevel () { return this.second },
    // json第三階層 ScanBand、Wi-FiTxPowerSetting、Wi-FiRoamingSetting
    thridLevel () {
      const lv1 = THIRD_LEVEL_MENU[this.firstLevel] || {}
      const lv2 = lv1[this.secondLevel] || []
      return (lv2[0] && lv2[0].item) || []
    }
  },
  created () {
    this.rebuild()
  },
  watch: {
    first () { this.rebuild() },
    second () { this.rebuild() },
  },
  methods: {
    // テーブル再構築
    rebuild () {
      this.tableData = this.createTableRow()
      this.$nextTick(this.expandPreopenedRows)
    },

    // 展開・折り畳みアクション（第1階層）
    toggleRow (row) {
      row.expanded = !row.expanded
      const table = this.$refs.tableRef
      if (table && table.toggleRowExpansion) {
        // Element UI 2.x は第2引数で明示展開が可能
        table.toggleRowExpansion(row, row.expanded)
      }
    },

    // 第2階層の行に背景色を付ける
    getRowStyle ({ row }) {
      if (row.level === 1) return { backgroundColor: '#f5f5f5' }
      return {}
    },

    // データ生成（Vue 3 の createTableRow 相当）
    createTableRow () {
      const rows = []
      this.expandedRows = []

      const setting = this.setting
      const firstLevel = this.firstLevel
      const secondLevel = this.secondLevel
      const thridLevel = this.thridLevel

      thridLevel.forEach((ele, d1Index) => {
        // 第一階層
        const top = {
          id: `${d1Index}`,
          label: ele.label,
          value:
            d1Index === 0
              ? null
              : `${setting[firstLevel][secondLevel][ele.name][ele.item[0].name]} dBm`,
          expandable: d1Index === 0,
          expanded: false,
          level: 0,
          children: [],
        }

        // 第二階層
        top.children = (ele.item || [])
          .map((child, d2Index) => {
            const labelInfo = BC.NETWORK.WIFI.SCAN_BANDS
            if (child && child.prop) {
              const id = `${d1Index}-${d2Index}`
              // 常時展開する対象として記録（＝第2階層を常にオープン）
              this.expandedRows.push(id)
              return {
                id,
                label: child.label,
                level: 1,
                // 第三階層
                children: (labelInfo[child.prop].ITEMS || []).map((gchild, d3Index) => {
                  const enabled = setting[firstLevel][secondLevel][ele.name][child.name][d3Index] === BC.COMMON.TOGGLE.ENABLE
                  return {
                    id: `${d1Index}-${d2Index}-${d3Index}`,
                    label: `${gchild} ch`,
                    value: enabled ? '✓' : '',
                    level: 2,
                  }
                }),
              }
            }
            return null
          })
          .filter(Boolean)

        rows.push(top)
      })

      return rows
    },

    // 初期展開（第2階層を常時展開したい挙動を Element UI 2.x で再現）
    expandPreopenedRows () {
      const table = this.$refs.tableRef
      if (!table || !table.toggleRowExpansion) return

      // id パス（例: "0-1-2"）の祖先から順に展開
      const expandPath = (id) => {
        const parts = id.split('-')
        let currentId = ''
        let rows = this.tableData
        for (let i = 0; i < parts.length; i++) {
          currentId = i === 0 ? parts[0] : `${currentId}-${parts[i]}`
          const row = rows.find(r => r.id === currentId)
          if (!row) break
          row.expanded = true
          table.toggleRowExpansion(row, true)
          rows = row.children || []
        }
      }

      this.expandedRows.forEach(expandPath)
    },
  },
}
</script>

<style scoped>
/* Element UI 2.x のデフォルト展開アイコンを隠す */
::v-deep .el-table__expand-icon,
::v-deep .el-tree-node__expand-icon,
::v-deep .el-table__placeholder {
  display: none !important;
}

/* 独自の展開・折り畳みアイコン、動作のアニメーション設定 */
.arrowIcon {
  cursor: pointer;
  transition: transform 0.3s ease;
}
.arrowIcon.rotated {
  transform: rotate(-90deg);
}

/* 子階層のフェードイン */
::v-deep .el-table__row--level-1,
::v-deep .el-table__row--level-2 {
  animation: fade-in 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes fade-in {
  from { opacity: 0; transform: translateY(-5px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
